import { StyledDescription, StyledHeader, StyledTitle } from './index.styled'

interface IProps {
  title?: string
  description?: string
}

const HeaderDescription = ({ title, description }: IProps) => {
  return (
    <StyledHeader className="header-description">
      <StyledTitle>{title}</StyledTitle>
      <StyledDescription>{description}</StyledDescription>
    </StyledHeader>
  )
}

export default HeaderDescription
